const sliderTimelineThumbnail = new Swiper('.timeline-slider__content-nav', {
  loop: false,
  slidesPerView: 4,
  spaceBetween: 4,
  watchSlidesProgress: true,
  breakpoints: {
    581: {
      spaceBetween: 8,
    },
  }
});

const sliderTimelineMain = new Swiper('.timeline-slider__content-main', {
  spaceBetween: 12,
  slidesPerView: 1,
  loop: false,
  thumbs: {
    swiper: sliderTimelineThumbnail
  },
  breakpoints: {
    581: {
      slidesPerView: 2,
    },
    981: {
      slidesPerView: 4,
    },
  }
});